export default __webpack_public_path__ + "static/media/envelope.7fbbd69c.svg";